import { createRouter, createWebHashHistory } from 'vue-router';


const routes = [
    {
        path: '/',
        name: 'dashboard',
        component: () => import('./components/Dashboard.vue')
    },
    {
        path: '/config',
        name: 'config',
        component: () => import('./components/Config.vue')
    },
    {
        path: '/usuarios',
        name: 'usuarios',
        component: () => import('./components/Usuarios.vue')
    },
    {
        path: '/grupos',
        name: 'grupos',
        component: () => import('./components/Grupos.vue')
    },
    {
        path: '/clientes',
        name: 'clientes',
        component: () => import('./components/Clientes.vue')
    },
    {
        path: '/propClientes',
        name: 'propClientes',
        component: () => import('./components/PropClientes.vue')
    },
    {
        path: '/contratos',
        name: 'contratos',
        component: () => import('./components/Contratos.vue')
    },
    {
        path: '/softwares',
        name: 'softwares',
        component: () => import('./components/Softwares.vue')
    },
    {
        path: '/propSoftwares',
        name: 'propSoftwares',
        component: () => import('./components/PropSoftwares.vue')
    },
    {
        path: '/servicos',
        name: 'servicos',
        component: () => import('./components/Servicos.vue')
    },
    {
        path: '/propServicos',
        name: 'propServicos',
        component: () => import('./components/PropServicos.vue')
    },
    {
        path: '/chamados',
        name: 'chamados',
        component: () => import('./components/Chamados/Chamados.vue')
    },
    {
        path: '/chamados/filas',
        name: 'chamados_filas',
        component: () => import('./components/Chamados/Filas.vue')
    },
    {
        path: '/chamados/requisicoes',
        name: 'chamados_requisicoes',
        component: () => import('./components/Chamados/Requisicoes.vue')
    },
    {
        path: '/chamados/acoes',
        name: 'chamados_acoes',
        component: () => import('./components/Chamados/Acoes.vue')
    },
    {
        path: '/fcerta-utils/rotas',
        name: 'fcerta-utils_rotas',
        component: () => import('./components/FCertaUtils/Rotas.vue')
    },
    {
        path: '/fcerta-utils/convenioSanasa',
        name: 'fcerta-convenio_sanasa',
        component: () => import('./components/FCertaUtils/ConvenioSanasa.vue')
    },
    {
        path: '/InteligVarejo/funcoes',
        name: 'InteligVarejo_funcoes',
        component: () => import('./components/InteligVarejo/Funcoes.vue')
    },
    {
        path: '/InteligVarejo/empresas',
        name: 'InteligVarejo_empresas',
        component: () => import('./components/InteligVarejo/Empresas.vue')
    },
    {
        path: '/InteligVarejo/colaboradores',
        name: 'InteligVarejo_colaboradores',
        component: () => import('./components/InteligVarejo/Colaboradores.vue')
    },
    {
        path: '/InteligVarejo/relatorios',
        name: 'InteligVarejo_relatorios',
        component: () => import('./components/InteligVarejo/Relatorios.vue')
    },
    {
        path: '/InteligVarejo/relatorioperdas',
        name: 'InteligVarejo_relatorioperdas',
        component: () => import('./components/InteligVarejo/RelatorioPerdas.vue')
    },
    {
        path: '/crm/analiseReprov',
        name: 'analiseReprov',
        component: () => import('./components/CRM/AnaliseReprovados.vue')
    },
    {
        path: '/bi/bi-pharma',
        name: 'bi-pharma',
        component: () => import('./components/BI/BIPharma.vue')
    },
    {
        path: '/bi/bi-metas',
        name: 'bi-metas',
        component: () => import('./components/BI/BIEfficaxMeta.vue')
    },
    {
        path: '/bi/bi-config',
        name: 'bi-config',
        component: () => import('./components/BI/BIEfficaxConfig.vue')
    },
    {
        path: '/bi/bi-metas-monitor',
        name: 'bi-metas-monitor',
        component: () => import('./components/BI/BIEfficaxMetaMonitor.vue')
    },
    {
        path: '/bi/bi-metas-monitor-orcamentos',
        name: 'bi-metas-monitor-orcamentos',
        component: () => import('./components/BI/BIEfficaxMetaMonitorOrcamentos.vue')
    },
    {
        path: '/report/admin',
        name: 'report-admin',
        component: () => import('./components/Report/ReportAdmin.vue')
    },
    {
        path: '/report/schedule',
        name: 'report-schedule',
        component: () => import('./components/Report/ReportSchedule.vue')
    },
    {
        path: '/report/reports',
        name: 'report-reports',
        component: () => import('./components/Report/Reports.vue')
    },
    {
        path: '/powerbi/account',
        name: 'powerbi-account',
        component: () => import('./components/PowerBI/PowerBIAccount.vue')
    },
    {
        path: '/powerbi/report',
        name: 'powerbi-report',
        component: () => import('./components/PowerBI/PowerBIReport.vue')
    },
    {
        path: '/powerbi/reports/:reportName?',
        name: 'powerbi-reports',
        component: () => import('./components/PowerBI/PowerBIReports.vue')
    },
    {
        path: '/powerbi/reports-img/:reportName?',
        name: 'powerbi-reports-img',
        component: () => import('./components/PowerBI/PowerBIReportsImg.vue')
    },
    {
        path: '/powerbi/reports-manual',
        name: 'powerbi-reports-manual',
        component: () => import('./components/PowerBI/PowerBIReportsManual.vue')
    },
    {
        path: '/qlik/reports',
        name: 'qlik-reports',
        component: () => import('./components/Qlik/QlikReport.vue')
    },
    {
        path: '/qlik/admin',
        name: 'qlik-admin',
        component: () => import('./components/Qlik/QlikAdmin.vue')
    },
    {
        path: '/intelig-neg/metas-definir',
        name: 'intelig-neg-metas-definir',
        component: () => import('./components/InteligNeg/InteligNegocMetaDefinir.vue')
    },
    {
        path: '/intelig-neg/metas-monitor',
        name: 'intelig-neg-metas-monitor',
        component: () => import('./components/InteligNeg/InteligNegocMetaMonitor.vue')
    },
    {
        path: '/intelig-neg/metas-acompanhamento',
        name: 'intelig-neg-metas-acompanhamento',
        component: () => import('./components/InteligNeg/InteligNegocMetaAcompanhamento.vue')
    },
    {
        path: '/intelig-neg/medidas',
        name: 'intelig-neg-medidas',
        component: () => import('./components/InteligNeg/InteligNegocMedidas.vue')
    },    
    {
        path: '/bi/bi-metas-acompanhamento',
        name: 'bi-metas-acompanhamento',
        component: () => import('./components/BI/BIEfficaxMetaAcompanhamento.vue')
    },
    {
        path: '/elt/dw',
        name: 'elt-dw',
        component: () => import('./components/ELT/DW.vue')
    },
    {
        path: '/elt/templateDW',
        name: 'elt-dw-template',
        component: () => import('./components/ELT/DWTemplate.vue')
    },
    {
        path: '/elt/dwSQL',
        name: 'elt-dw-sql',
        component: () => import('./components/ELT/DWSQL.vue')
    },
    {
        path: '/elt/job',
        name: 'elt-job',
        component: () => import('./components/ELT/Job.vue')
    },
    {
        path: '/elt/jobAgente',
        name: 'elt-jobAgente',
        component: () => import('./components/ELT/JobAgente.vue')
    },
    {
        path: '/api/apis',
        name: 'api-apis',
        component: () => import('./components/Api/ApiAdmin.vue')
    },
    {
        path: '/api/tokens',
        name: 'api-tokens',
        component: () => import('./components/Api/ApiTokenAdmin.vue')
    },
    {
        path: '/api/logs',
        name: 'api-logs',
        component: () => import('./components/Api/ApiLogsAdmin.vue')
    },
    {
        path: '/snap/hipcom-balancos',
        name: 'snap-hipcom-balancos',
        component: () => import('./components/Snap/SnapHipcomBalancos.vue')
    },
    {
        path: '/snap/hipcom-agrupamento',
        name: 'snap-hipcom-agrupamento',
        component: () => import('./components/Snap/SnapHipcomAgrupamento.vue')
    },
    {
        path: '/snap/hipcom-contagem',
        name: 'snap-hipcom-contagem',
        component: () => import('./components/Snap/SnapHipcomContagem.vue')
    },
    {
        path: '/snap/bi-empresas',
        name: 'snap-bi-empresas',
        component: () => import('./components/Snap/SnapBIEmpresas.vue')
    },
    {
        path: '/snap/bi-rateio',
        name: 'snap-bi-rateio',
        component: () => import('./components/Snap/SnapBIRateio.vue')
    },
    {
        path: '/snap/bi-centrocusto',
        name: 'snap-bi-centrocusto',
        component: () => import('./components/Snap/SnapBICentroCusto.vue')
    },
    {
        path: '/snap/bi-classificar-nfs',
        name: 'snap-bi-classificar-nfs',
        component: () => import('./components/Snap/SnapBIClassificarNFs.vue')
    },
    {
        path: '/snap/frota-frotas',
        name: 'snap-frota-frotas',
        component: () => import('./components/Snap/SnapFrotaFrotas.vue')
    },
    {
        path: '/snap/frota-veiculos',
        name: 'snap-frota-veiculos',
        component: () => import('./components/Snap/SnapFrotaVeiculo.vue')
    },
    {
        path: '/snap/frota-associar-despesas',
        name: 'snap-frota-associar-despesas',
        component: () => import('./components/Snap/SnapFrotaAssociarDespesas.vue')
    },
    {
        path: '/snap/frota-lancamento-despesas',
        name: 'snap-frota-lancamento-despesas',
        component: () => import('./components/Snap/SnapFrotaLancamentoDespesas.vue')
    },
    {
        path: '/snap/bi-lancamentos-cc',
        name: 'snap-bi-lancamentos-cc',
        component: () => import('./components/Snap/SnapBILancamentosCC.vue')
    },
    {
        path: '/snap/bi-lancamentos-contab',
        name: 'snap-bi-lancamentos-contab',
        component: () => import('./components/Snap/SnapBILancamentosContabeis.vue')
    },
    {
        path: '/snap/bi-lancamentos-nfs',
        name: 'snap-bi-lancamentos-nfs',
        component: () => import('./components/Snap/SnapBILancamentosNFs.vue')
    },
    {
        path: '/snap/bi-lancamentos-forn',
        name: 'snap-bi-lancamentos-forn',
        component: () => import('./components/Snap/SnapBILancamentosForn.vue')
    },
    {
        path: '/snap/bi-varejo-integracao-x7bank',
        name: 'snap-bi-varejo-integracao-x7bank',
        component: () => import('./components/Snap/SnapIntegracaoX7Bank.vue')
    },
    {
        path: '/crm/acoes',
        name: 'crmacoes',
        component: () => import('./components/CRM/CRMAcoes.vue')
    },
    {
        path: '/crm/interacoes',
        name: 'crminteracoes',
        component: () => import('./components/CRM/CRMInteracoes.vue')
    },
    {
        path: '/empty',
        name: 'empty',
        component: () => import('./components/EmptyPage.vue')
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('./pages/Login.vue')
    },
    {
        path: '/error',
        name: 'error',
        component: () => import('./pages/Error.vue')
    },    
    {
        path: '/access',
        name: 'access',
        component: () => import('./pages/Access.vue')
    },
    {
        path: '/:catchAll(.*)',
        name: 'notfound',
        component: () => import('./pages/NotFound.vue')
    }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior () {
        return { left: 0, top: 0 };
    }
});

export default router;
